


if (document.querySelector('.map-container')) {
    const el = document.querySelector('.map-container');
    const mapImage = document.querySelector('.map-container > img');
    const firstKey = document.querySelector('.hotspot:first-child');
    const dims = el.getBoundingClientRect();
    const hotspotKeys = document.querySelectorAll(".hotspot");
    const hotspotLabelMob = document.querySelector(".mobile-hotspot-info");
    const labelKey = hotspotLabelMob.querySelector(".key");
    const labelName = hotspotLabelMob.querySelector(".name");


    const screenSize = {
        "w": Math.max(document.documentElement.clientWidth, window.innerWidth || 0),
        "h": Math.max(document.documentElement.clientHeight, window.innerHeight || 0)
    };


   let intance = null;

    // if (window.is_touch) {

    if (window.innerWidth < 768) {
        instance = panzoom(el, {
            beforeWheel: function(e) {
                // allow wheel-zoom only if altKey is pressed. Otherwise - ignore
                var shouldIgnore = !e.altKey;
                return shouldIgnore;
            },

            maxZoom: 3,
            minZoom: 1,
            initialZoom: 1,
            // initialY: 15000,
            bounds: true,
            boundsPadding: 1,
        });

        instance.smoothZoom(3000, 4000, 1.05);
    }

    // Zoom buttons
    const zoomInButton = document.querySelector('.panzoom-map .btn-zoom-in');
    const zoomOutButton = document.querySelector('.panzoom-map .btn-zoom-out');

    zoomInButton.addEventListener("click", zoomIn);
    zoomInButton.addEventListener("touchstart", zoomIn);
    zoomOutButton.addEventListener("click", zoomOut);
    zoomOutButton.addEventListener("touchstart", zoomOut);

    function zoomIn() {
        instance.smoothZoom(0, 0, 1.3);
        console.log('zoom-in');
    }

    function zoomOut() {
        instance.smoothZoom(0, 0, 0.7);
        console.log('zoom-out');
    }


    // Map hotspots
    const selectHotspot = (e) => {
        const clickedHotspot = e.target.parentElement;
        const hotspotContainer = clickedHotspot.parentElement;
        const hotspots = hotspotContainer.querySelectorAll(".hotspot");

        hotspots.forEach(hotspot => {
            if (hotspot === clickedHotspot) {
                hotspot.classList.toggle("selected");
                if (!window.is_touch) {
                    centerOn(hotspot);
                }

            } else {
                hotspot.classList.remove("selected");
                if (window.is_touch) {
                    unselectHotspotMobile();
                }
            }
        });
    }

    (() => {
        const buttons = document.querySelectorAll(".hotspot-button");
        buttons.forEach(button => {
            button.addEventListener("click", selectHotspot);
            button.addEventListener("touchstart", selectHotspot);
            button.addEventListener("focus", selectHotspot);
        });
    })();




    function centerOn(ui) { // Fix Panzoom centerOn function for non-svg map

        const parent = ui.parentNode;
        if (!parent) throw new Error('ui element is required to be within the scene');

        const clientRect = ui.getBoundingClientRect();
        const cx = clientRect.left + clientRect.width / 2;
        const cy = clientRect.top + clientRect.height / 2;

        const container = parent.getBoundingClientRect();
        const dx = container.width / 2 - cx;
        const dy = container.height / 2 - cy;

        // internalMoveBy(dx, dy, true);
        // instance.moveBy(dx, dy, true);
        instance.smoothMoveTo(dx, dy);
    }



    for (let i = 0, len = hotspotKeys.length; i < len; i++) {
        hotspotKeys[i].addEventListener('touchstart', function (e) {
            // e.preventDefault();
            let curKey = this.querySelector('.hotspot-button').innerText;
            let curName = this.querySelector('.hotspot-label').innerText;

            this.classList.toggle("active");

            hotspotLabelMob.classList.add("active");
            labelKey.innerText = curKey;
            labelName.innerText = curName;
        }, false);
    }


function unselectHotspotMobile() {
    hotspotLabelMob.classList.remove("active");
    labelKey.innerText = '';
    labelName.innerText = 'DRAG MAP TO EXPLORE';
}

// function selectHotspotMobile() {
//
// }


} // endif map-container


